<template>
  <div class="meeting-reschedule-modal">
    <HMModalHeader
      :title="$t('MARKETING.TITLES.RESCHEDULE_MEETING')"
      @close="$emit('close')"
    />
    <PublicSchedulingCalendar
      :studioURL="studioURL"
      :meetingType="meetingType"
      :preselectedDate="currentDateTime"
      :isBooking="isRescheduling"
      @selectedSlot="selectSlot"
    />
  </div>
</template>

<script>
import PublicSchedulingCalendar from '../../components/products/PublicSchedulingCalendar';
import { errorToMessage } from '../../../core/utils/errors';

export default {
  name: 'MeetingRescheduleModal',
  components: {
    PublicSchedulingCalendar,
  },
  props: {
    studioURL: {
      type: String,
    },
    meetingType: {
      type: Object,
    },
    currentDateTime: {
      type: Date,
    },
    onMeetingRescheduled: null,
  },
  data() {
    return {
      isRescheduling: false,
      selectedSlot: this.currentDateTime,
      timezone: null,
    };
  },
  methods: {
    async selectSlot({ selectedSlot, selectedTimezone }) {
      this.selectedSlot = selectedSlot;
      this.timezone = selectedTimezone;
      this.isRescheduling = true;
      try {
        await this.onMeetingRescheduled(this.selectedSlot, this.timezone);
        this.$emit('close');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Rescheduling failed. Try again later.',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isRescheduling = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
